import { useEffect, useState } from 'react';
import type { Optional } from '@gov-nx/core/types';

interface Queue<T extends { id: string }> {
	add: (item: T) => void;
	remove: (item: T) => void;
	first: Optional<T>;
}

export const useQueue = <T extends { id: string }>({
	onNewItem,
}: {
	onNewItem: (item: T) => void;
}): Queue<T> => {
	const [queue, setQueue] = useState<{ item: T; isProcessing: boolean }[]>([]);

	useEffect(() => {
		const [first] = queue;
		if (first && !first.isProcessing) {
			setQueue((items) =>
				items.map((item) =>
					item.item.id === first.item.id
						? { ...item, isProcessing: true }
						: item
				)
			);

			onNewItem(first.item);
		}
	}, [onNewItem, queue]);

	return {
		add: (item) =>
			setQueue((items) => [...items, { item, isProcessing: false }]),
		remove: (item) =>
			setQueue((items) => items.filter((f) => f.item.id !== item.id)),
		first: queue[0]?.item,
	};
};
